import logo from '../../images/logo.webp';
import './Header.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';
import {Button} from "react-bootstrap";
import {useState} from "react";
import ContactDialog from "../ContactDialog";

export const Header = () => {
    const [contact, setContact] = useState(false);

    return <nav className="navbar navbar-light bg-light justify-content-between fixed-top">
        <img src={logo} alt={'Kolu'} style={{height: 38}} />
        <Button variant={'main'} onClick={() => setContact(true)}><FontAwesomeIcon icon={faHeadset} /> Contacteer ons</Button>
        <ContactDialog setContact={setContact} contact={contact} />
    </nav>;
}